/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

export type Consent = {
  status: number
  updatedAt: string
}

export type ComplianceSettings = {
  consents: {
    analytics: Consent
    custom_consent: Consent
    remarketing: Consent
  }
}

export function getComplianceSettings(cb: Function) {
  function handleChangeComplianceSettings(settings: ComplianceSettings) {
    window.snx_piwik_compliance_settings = settings

    console.log('[CONSENT] Compliance settings updated:', settings)

    if (typeof cb === 'function') {
      cb(settings)
    }
  }

  window.ppms.cm.api(
    'getComplianceSettings',
    handleChangeComplianceSettings,
    console.error,
  )
}

export function initConsent() {
  const consentToggles = Array.from(
    document.querySelectorAll('a[href$="#js-consent-open"]'),
  )

  for (const toggle of consentToggles) {
    if (toggle instanceof HTMLElement) {
      if (toggle.dataset.hydrated) continue
      toggle.dataset.hydrated = 'true'

      toggle.addEventListener('click', (e) => {
        e.preventDefault()
        window.ppms.cm.api('openConsentForm', () => {}, console.error)
        const dialog = toggle.closest('dialog')
        if (dialog instanceof HTMLDialogElement) {
          dialog.close()
        }
      })
    }
  }

  window.addEventListener('snx-consent-change', () => {
    getComplianceSettings(() => {
      window.dispatchEvent(new CustomEvent('hydrate'))
    })
  })
}

declare global {
  interface Window {
    snx_piwik_compliance_settings: ComplianceSettings | null
    ppms: {
      cm: {
        api: (
          action: string,
          onSuccess: (args?: ComplianceSettings) => void,
          onError: (err: Error) => void,
        ) => void
      }
    }
  }
}
